module.exports = __webpack_public_path__ + "assets/img/img_tv.4e56d696.png";